import { Controller } from "@hotwired/stimulus"
import { turboFetch } from "../util"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    turboFetch(this.urlValue, { method: "get" })
  }
}
